module.exports = __webpack_public_path__ + "static/media/concept-energy-label-f.f174ae1b.svg";